import React from "react";
import FileViewer from "./file-viewer";
import useFileViewerStore from "../../stores/fileViewerStore";
import useAlertStore from "../../stores/alertStore";
import useIsMobile from "../../hooks/useIsMobile";
import { saveFile } from "../../utils/helpers";
import { readableMessage } from "../../utils/http-error";

/** Above the side modals that most documents are opened from. */
const VIEWER_Z_INDEX = 10050;

const GlobalFileViewer: React.FC = () => {
    const file = useFileViewerStore((state) => state.file);
    const close = useFileViewerStore((state) => state.close);
    const showAlert = useAlertStore((state) => state.showAlert);
    const phone = useIsMobile();

    if (!file) return null;

    const save = async () => {
        try {
            await saveFile(file.blob, file.name);
        } catch (error) {
            showAlert("error", readableMessage(error));
        }
    };

    return <FileViewer file={file} phone={phone} onClose={close} onDownload={save} zIndex={VIEWER_Z_INDEX} />;
};

export default GlobalFileViewer;
